import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限  - 附件管理
    AUTH_ATTACH() {
      return hasApiMenuPermission('and', ['auth_attach', 'auth_attach_tree', 'auth_attach_search']);
    },

    // 权限 - 附件管理 - 新增目录
    AUTH_ATTACH_DIR_ADD() {
      return hasApiMenuPermission('and', ['auth_attach_dir_add']);
    },

    // 权限 - 附件管理 - 编辑目录
    AUTH_ATTACH_DIR_EDIT() {
      return hasApiMenuPermission('and', ['auth_attach_dir_edit']);
    },

    // 权限 - 附件管理 - 重命名目录
    AUTH_ATTACH_DIR_RENAME() {
      return hasApiMenuPermission('and', ['auth_attach_dir_rename']);
    },

    // 权限 - 附件管理 - 删除目录
    AUTH_ATTACH_DIR_DELETE() {
      return hasApiMenuPermission('and', ['auth_attach_dir_delete']);
    },

    // 权限 - 附件管理 - 批量删除目录
    AUTH_ATTACH_DIR_DELETE_BATCH() {
      return hasApiMenuPermission('and', ['auth_attach_dir_delete_batch']);
    },

    // 权限 - 附件管理 - 上传文件
    AUTH_ATTACH_FILE_UPLOAD() {
      return hasApiMenuPermission('and', ['auth_attach_file_upload']);
    },

    // 权限 - 附件管理 - 删除文件
    AUTH_ATTACH_FILE_DELETE() {
      return hasApiMenuPermission('and', ['auth_attach_file_delete']);
    },

    // 权限 - 附件管理 - 编辑文件
    AUTH_ATTACH_FILE_EDIT() {
      return hasApiMenuPermission('and', ['auth_attach_file_edit']);
    },

    // 权限 - 附件管理 - 分享
    AUTH_ATTACH_SHARE() {
      return hasApiMenuPermission('and', ['auth_attach_share']);
    },

    // 权限 - 附件管理 - 获取分享信息
    AUTH_ATTACH_SHARE_INFO() {
      return hasApiMenuPermission('and', ['auth_attach_share_info']);
    },
  },
};
